var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-contain',[_vm._v(" base update ")])
}
var staticRenderFns = []

export { render, staticRenderFns }